import React from 'react';
import { Icon } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';
import styles from './proxyBanner.css';
import { useImpersonationMode } from '../../hooks/useImpersonationMode';

export const ProxyBanner = () => {
  const { isLoading, impersonatedUser, isImpersonating } = useImpersonationMode();

  if (isLoading || !isImpersonating || !impersonatedUser) {
    return null;
  }

  return <div className={styles.banner} data-test-id="proxy-banner">
    <a
      className={styles.link}
      data-test-id="proxy-banner-link"
      href="https://climate.com/static/dealer/#/">
      <Icon glyph={Icon.set.ARROW_BACK} />
      {getMessage('proxyBanner.backToClimatePortal')}
    </a>
    <div className={styles.divider} />
    <div className={styles.details} data-test-id="proxy-banner-details">
      {getMessage('proxyBanner.youAreViewingAs')} {`${impersonatedUser.details.firstName} ${impersonatedUser.details.lastName} (${impersonatedUser.details.email})`}
    </div>
  </div>;
};
